import { render, staticRenderFns } from "./RegionPicker.vue?vue&type=template&id=28124ef6&scoped=true&"
import script from "./RegionPicker.vue?vue&type=script&lang=js&"
export * from "./RegionPicker.vue?vue&type=script&lang=js&"
import style0 from "./RegionPicker.vue?vue&type=style&index=0&id=28124ef6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28124ef6",
  null
  
)

export default component.exports